import { form } from '../../formState'

import { useIsSimulation } from '@/hooks'

import { Eligibility } from './Eligibility'
import { RecurrenceSettings } from './RecurrenceSettings'

import { useTexts } from '../useTexts'

export function EligibilityAndReccurrence() {
  const texts = useTexts()
  const isSimulation = useIsSimulation()

  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {texts.getEligibilityAndReccurenceTitle}
      </form.SectionTitle>
      {!isSimulation && <RecurrenceSettings inEditMode />}
      <Eligibility />
    </form.Fieldset>
  )
}
